/**
 * @file Mobile Nav.
 */
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Mobile Nav Component.
 */
const vMobileNav = () => {
	const navTrigger    = document.querySelector('.v-header__menu-trigger');
	const navigation    = document.querySelector('.v-mobile-nav');
	const mobileOverlay = document.querySelector('.v-mobile-overlay');
	const navParents    = navigation.querySelectorAll('.menu-item-has-children > a');
	const navBack       = navigation.querySelector('.v-mobile-nav__back-button');
	const mobileSearch  = navigation.querySelector('.v-mobile-nav__search');
	const mobileUtility = navigation.querySelector('.v-mobile-nav__utility-list');
	const mobileLogo    = navigation.querySelector('.v-mobile-nav__logo-link');
	const header        = document.querySelector('.v-header');
	const body          = document.querySelector('body');
	const html          = document.querySelector('html');
	const fullBody      = document.querySelector('.full-body');
	let currentMenu     = null;
	let navIsOpen       = false;
	let menuIsChanging  = false;

	gsap.registerPlugin(ScrollToPlugin);

	/**
	 * Close.
	 */
	function closeNav() {
		gsap.to(navigation, {
			translateX: '100%',
			duration:   0.4,
			onComplete: () => {
				navigation.classList.remove('visible');
				navigation.classList.remove('open');
				navigation.removeAttribute('style');
				// mobileNav.setAttribute('aria-hidden', 'true');
				// mobileNav.setAttribute('tabindex', '-1');
				body.classList.remove('mobile-nav-open');
				html.classList.remove('mobile-nav-open');
				window.scrollTo(0, 0);
				fullBody.scrollLeft = 0;
			},
		});
		mobileOverlay.classList.remove('open');
		mobileOverlay.setAttribute('aria-hidden', 'true');
		mobileOverlay.setAttribute('tabindex', '-1');
		navTrigger.classList.remove('open');
		navIsOpen           = false;
		window.scrollTo(0, 0);
		fullBody.scrollLeft = 0;
	}

	mobileOverlay.addEventListener('click', () => {
		closeNav();
		navTrigger.focus();
	});

	header.addEventListener('focusout', () => {
		if (!navIsOpen) {
			return;
		}
		setTimeout(() => {
			if (
				navigation.contains(document.activeElement)
        || document.activeElement === navTrigger
        || document.activeElement === mobileOverlay
			) {
				return;
			}
			closeNav();
		}, 0);
	});

	navTrigger.addEventListener('click', () => {
		if (navIsOpen) {
			closeNav();
			navTrigger.focus();
		} else {
			navigation.classList.add('visible');
			gsap.to(navigation, {
				translateX: 0,
				duration:   0.4,
				onComplete: () => {
					navigation.classList.add('open');
					navigation.removeAttribute('style');
					navigation.focus();
				},
			});
			gsap.to(window, {
				scrollTo:   0,
				duration:   0.4,
				onComplete: () => {
					body.classList.add('mobile-nav-open');
					html.classList.add('mobile-nav-open');
					window.scrollTo(0, 0);
					fullBody.scrollLeft = 0;
				},
			});
			mobileOverlay.classList.add('open');
			mobileOverlay.setAttribute('aria-hidden', 'false');
			mobileOverlay.setAttribute('tabindex', '0');
			// mobileNav.setAttribute('aria-hidden', 'false');
			// mobileNav.setAttribute('tabindex', '0');
			navTrigger.classList.add('open');
			navIsOpen = true;
		}
	});

	/**
	 * Changes the menu.
	 *
	 * @param {Event} e - Click event.
	 */
	function changeNav(e) {
		e.preventDefault();
		if (menuIsChanging) {
			return;
		}
		menuIsChanging = true;

		const link        = this;
		const menu        = this.nextElementSibling;
		const item        = this.parentNode;
		const parentMenu  = this.parentNode.parentNode;
		menu.classList.add('visible');
		menu.style.zIndex = 99;

		navBack.setAttribute('aria-hidden', 'false');
		navBack.setAttribute('tabindex', '0');
		navBack.classList.add('visible');
		mobileLogo.setAttribute('aria-hidden', 'true');
		mobileLogo.setAttribute('tabindex', '-1');
		mobileLogo.classList.add('hidden');

		gsap.to(menu, {
			translateX: 0,
			duration:   0.4,
			onComplete: () => {
				if (parentMenu.classList.contains('v-mobile-nav__list')) {
					mobileSearch.style.display  = 'none';
					mobileUtility.style.display = 'none';
				}

				[...parentMenu.children].filter((child) => child !== item).forEach((child) => {
					child.style.display = 'none';
				});

				link.style.display = 'none';
				item.setAttribute('tabindex', '-1');
				// set tabindex to -1 so it's not reachable by keyboard

				menu.focus();
				menu.classList.add('open');
				menu.removeAttribute('style');
				currentMenu    = menu;
				menuIsChanging = false;
			},
		});
	}
	[...navParents].forEach((np) => np.addEventListener('click', changeNav));

	/**
	 * Back.
	 */
	function backNav() {
		if (!currentMenu) {
			return;
		}
		if (menuIsChanging) {
			return;
		}
		menuIsChanging = true;

		const link       = currentMenu.previousElementSibling;
		const menu       = currentMenu;
		const item       = currentMenu.parentNode;
		const parentMenu = currentMenu.parentNode.parentNode;

		if (parentMenu.classList.contains('v-mobile-nav__list')) {
			navBack.setAttribute('aria-hidden', 'true');
			navBack.setAttribute('tabindex', '-1');
			navBack.classList.remove('visible');
			mobileLogo.setAttribute('aria-hidden', 'false');
			mobileLogo.setAttribute('tabindex', '0');
			mobileLogo.classList.remove('hidden');

			mobileSearch.removeAttribute('style');
			mobileUtility.removeAttribute('style');
		}

		[...parentMenu.children].filter((child) => child !== item).forEach((child) => {
			child.removeAttribute('style');
		});

		link.removeAttribute('style');
		item.removeAttribute('tabindex');
		link.focus();

		gsap.to(menu, {
			translateX: '100%',
			duration:   0.4,
			onComplete: () => {
				menu.classList.remove('open');
				menu.classList.remove('visible');
				menu.removeAttribute('style');
				currentMenu    = parentMenu;
				menuIsChanging = false;
			},
		});
	}
	navBack.addEventListener('click', backNav);
};
export default vMobileNav;
